<mat-card style="text-align: center;" *ngIf="newVersion$ | async">
  <p>New version available</p>
  <button mat-raised-button color="primary" (click)="onUpdate()">Update</button>
</mat-card>
